// Accessibility Style Plugin
export default {
    id: 'accessibility',
    label: 'Accessibility',
    icon: 'Eye',
    properties: {
        forcedColorAdjust: {
            label: 'Forced Color Adjust',
            type: 'select',
            options: ['auto', 'none'],
            default: 'auto',
            toClass: (value) => value ? `forced-color-adjust-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^forced-color-adjust-(.+)$/);
                return match ? match[1] : null;
            }
        }
    }
};
